
import AppWeekdaySelect from "@/components/common/WeekDaySelect.vue";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { IFrequencyObject } from "@/utils/frequency-object";

export default Vue.extend({
	props: {
		value: {
			type: Object as () => IFrequencyObject,
			required: true
		},
		xs: {
			type: [String,Number],
			default: "12"
		},
		md: {
			type: [String, Number],
			default: "6"
		}
	},
	computed: {
		whichDaySelectItems():ISelectItem<number>[] {
			return [
				...[1, 2, 3, 4, 5].map(n => {
					return {
						value: n,
						text: this.$ct(`which.${n}`)
					};
				}),
				{
					value: -1,
					text: this.$ct("which.last")
				}
			];
		},
		whichDay():number {
			return parseInt(this.value.FrequencyMoment.split("/")[0]) || 1;
		},
		weekday():number {
			return parseInt(this.value.FrequencyMoment.split("/")[1]) || 0;
		}
	},
	methods: {
		setWhichDay(val:number) {
			let split = this.value.FrequencyMoment.split("/");
			split[0] = `${val}`;
			this.value.FrequencyMoment = split.join("/");
		},
		setWeekDay(weekday:number) {
			let split = this.value.FrequencyMoment.split("/");
			split[1] = `${weekday}`;
			this.value.FrequencyMoment = split.join("/");
		}
	},
	components: {
		AppWeekdaySelect
	},
	i18nEx: {
		componentPrefix: "components.frequency-documents"
	}
});
